import qt from "../models/backend-errors.js";
import ue from "../models/braze-event.js";
import {
  convertMsToSeconds as l,
  convertSecondsToMs as Xt
} from "../util/date-utils.js";
import s from "../common/event-logger.js";
import { isArray as p, isEqual as ii } from "../util/code-utils.js";
import r from "../../shared-lib/braze-shared-lib.js";
import { STORAGE_KEYS as o } from "./storage-manager.js";
export default class Pt {
  constructor(t, e, s, i, r, o, n, a, u, h, c) {
    (this.Ur = t),
      (this.h = e),
      (this.Go = s),
      (this.v = i),
      (this.j = r),
      (this.gt = o),
      (this._r = n),
      (this.Uo = a),
      (this.jo = u),
      (this.Vo = h),
      (this.$o = c),
      (this.sa = ["npm"]);
  }
  Ps(t, e) {
    const s = this.Ur.te(),
      i = s.Pi(),
      r = this.h.I(o.q.Xo);
    ii(r, i) || (t.device = i),
      (t.api_key = this._r),
      (t.time = l(new Date().valueOf(), !0));
    const n = this.h.I(o.q.oa) || [],
      a = this.h.I(o.q.ua) || "";
    if (
      (this.sa.length > 0 &&
        (!ii(n, this.sa) || a !== this.j.ha()) &&
        (t.sdk_metadata = this.sa),
      (t.sdk_version = this.jo),
      this.Vo && (t.sdk_flavor = this.Vo),
      (t.app_version = this.$o),
      (t.device_id = s.id),
      e)
    ) {
      const e = this.v.getUserId();
      null != e && (t.user_id = e);
    }
    return t;
  }
  Os(t, e, i) {
    const o = e.auth_error,
      n = e.error;
    if (!o && !n) return !0;
    if (o) {
      let e;
      this.Go.Vn();
      const s = { errorCode: o.error_code };
      for (const t of i)
        p(t) && "X-Braze-Auth-Signature" === t[0] && (s.signature = t[1]);
      t.respond_with && t.respond_with.user_id
        ? (s.userId = t.respond_with.user_id)
        : t.user_id && (s.userId = t.user_id);
      const n = o.reason;
      return (
        n
          ? ((s.reason = n), (e = `due to ${n}`))
          : (e = `with error code ${o.error_code}.`),
        this.Go.Jn() ||
          (e +=
            ' Please use the "enableSdkAuthentication" initialization option to enable authentication.'),
        r.D.error(`SDK Authentication failed ${e}`),
        this.ca(t.events, t.attributes),
        this.Go.Qn(s),
        !1
      );
    }
    if (n) {
      let i,
        o = n;
      switch (o) {
        case qt.la:
          return (
            (i = "Received successful response with empty body."),
            s.G(r.A.qs, { e: i }),
            r.D.info(i),
            !1
          );
        case qt.fa:
          return (
            (i = "Received successful response with invalid JSON"),
            s.G(r.A.qs, { e: i + ": " + e.response }),
            r.D.info(i),
            !1
          );
        case qt.ma:
          o = `The API key "${t.api_key}" is invalid for the baseUrl ${this.Uo}`;
          break;
        case qt.pa:
          o =
            "Sorry, we are not currently accepting your requests. If you think this is in error, please contact us.";
          break;
        case qt.Ra:
          o = "No device identifier. Please contact support@braze.com";
      }
      r.D.error("Backend error: " + o);
    }
    return !1;
  }
  ba(t, e, s, i) {
    return !!((t && 0 !== t.length) || (e && 0 !== e.length) || s || i);
  }
  ga(t, e, s, i) {
    const r = [],
      o = t => t || "",
      n = o(this.v.getUserId());
    let a,
      u,
      h,
      c,
      l = this.Oi(t, e);
    if (s.length > 0) {
      const t = [];
      for (const e of s) {
        if (((a = e.Pi()), this.Go.Jn())) {
          if (n && !a.user_id) {
            c || ((c = {}), (c.events = [])), c.events.push(a);
            continue;
          }
          if (o(a.user_id) !== n) {
            u || (u = []), u.push(a);
            continue;
          }
        }
        t.push(a);
      }
      t.length > 0 && (l.events = t);
    }
    if (i.length > 0) {
      const t = [];
      for (const e of i)
        this.Go.Jn() && o(e.user_id) !== n
          ? (h || (h = []), h.push(e))
          : t.push(e);
      t.length > 0 && (l.attributes = t);
    }
    if ((this.ca(u, h), (l = this.Ps(l, !0)), c)) {
      c = this.Ps(c, !1);
      const t = { requestData: c, headers: this.Bs(c) };
      r.push(t);
    }
    if (l && !this.ba(l.events, l.attributes, t, e)) return c ? r : null;
    const f = { requestData: l, headers: this.Bs(l) };
    return r.push(f), r;
  }
  ca(t, e) {
    if (t) {
      const e = [];
      for (const s of t) {
        const t = ue.fromJson(s);
        (t.time = Xt(t.time)), e.push(t);
      }
      this.h.bo(e);
    }
    if (e) for (const t of e) this.h.qa(t);
  }
  Vs(t, e) {
    let s = "HTTP error ";
    null != t && (s += t + " "), (s += e), r.D.error(s);
  }
  Fr(t) {
    return s.G(r.A.Aa, { n: t });
  }
  Oi(t, e, s) {
    const i = {};
    t && (i.feed = !0), e && (i.triggers = !0);
    const r = null != s ? s : this.v.getUserId();
    return (
      r && (i.user_id = r),
      (i.config = { config_time: this.gt.Zs() }),
      { respond_with: i }
    );
  }
  Bs(t, e, s, i) {
    const r = [["X-Braze-Api-Key", this._r]];
    let n = !1;
    if (
      (null != t.respond_with &&
        t.respond_with.triggers &&
        (r.push(["X-Braze-TriggersRequest", "true"]), (n = !0)),
      null != t.respond_with &&
        t.respond_with.feed &&
        (r.push(["X-Braze-FeedRequest", "true"]), (n = !0)),
      e)
    ) {
      r.push(["X-Braze-ContentCardsRequest", "true"]);
      let t = this.h.I(o.q.As);
      (t && i) || ((t = 0), this.h.B(o.q.As, t)),
        r.push(["BRAZE-SYNC-RETRY-COUNT", t.toString()]),
        (n = !0);
    }
    if (
      (s && (r.push(["X-Braze-FeatureFlagsRequest", "true"]), (n = !0)),
      n && r.push(["X-Braze-DataRequest", "true"]),
      this.Go.Jn())
    ) {
      const t = this.Go.Kn();
      null != t && r.push(["X-Braze-Auth-Signature", t]);
    }
    return r;
  }
  Gs(t, e) {
    const s = t.device;
    s && s.os_version instanceof Promise
      ? s.os_version.then(s => {
          (t.device.os_version = s), e();
        })
      : e();
  }
  Qs() {
    this.Go.Qs();
  }
  Ks() {
    return this.Uo;
  }
  addSdkMetadata(t) {
    for (const e of t) -1 === this.sa.indexOf(e) && this.sa.push(e);
  }
}
